const teamImages = {
  "arizona-cardinals": [
    "https://nogginboss.com/cdn/shop/files/CardinalsRed1_1080x.png?v=1690384097",
    "https://nogginboss.com/cdn/shop/files/CardinalsBlack1_1080x.png?v=1690384097",
    "https://nogginboss.com/cdn/shop/files/CardinalsGrey1_1080x.png?v=1690384097",
    "https://nogginboss.com/cdn/shop/files/CardinalsWhite1_1080x.png?v=1687799499",
    "https://nogginboss.com/cdn/shop/files/ARIZONACARDINALSCHROMEBLACK_1080x.jpg?v=1745460200",
    "https://nogginboss.com/cdn/shop/files/ARIZONACARDINALSCHROMESILVER_1080x.jpg?v=1745460200"
  ],
  "atlanta-falcons": [
    "https://nogginboss.com/cdn/shop/files/FalconsRed1_1080x.png?v=1690384108",
    "https://nogginboss.com/cdn/shop/files/FalconsBlack1_1080x.png?v=1690384108",
    "https://nogginboss.com/cdn/shop/files/FalconsGrey1_1080x.png?v=1690384108",
    "https://nogginboss.com/cdn/shop/files/FalconsWhite1_1080x.png?v=1687894872",
    "https://nogginboss.com/cdn/shop/files/ATLANTAFALCONSCHROMEBLACK_1080x.jpg?v=1745362568",
    "https://nogginboss.com/cdn/shop/files/ATLANTAFALCONSCHROMESILVER_1080x.jpg?v=1745362568"
  ],
  "balitmore-ravens": [
    "https://nogginboss.com/cdn/shop/files/RavensBlack1_1080x.png?v=1690384089",
    "https://nogginboss.com/cdn/shop/files/RavensGrey1_1080x.png?v=1690384089",
    "https://nogginboss.com/cdn/shop/files/RavensWhite1_1080x.png?v=1687894973",
    "https://nogginboss.com/cdn/shop/files/BALTIMORERAVENSCHROMEBLACK_1080x.jpg?v=1745460193",
    "https://nogginboss.com/cdn/shop/files/BALTIMORERAVENSCHROMESILVER_1080x.jpg?v=1745460193",
    "https://nogginboss.com/cdn/shop/files/BALTIMORERAVENSCHROMEGOLD_1080x.jpg?v=1745460193"
  ],
  "buffalo-bills": [
    "https://nogginboss.com/cdn/shop/files/BillsRed1_1080x.png?v=1690384118",
    "https://nogginboss.com/cdn/shop/files/BillsBlack1_1080x.png?v=1690384118",
    "https://nogginboss.com/cdn/shop/files/BillsGrey1_1080x.png?v=1690384118",
    "https://nogginboss.com/cdn/shop/files/BillsWhite1_1080x.png?v=1687895046",
    "https://nogginboss.com/cdn/shop/files/BUFFALOBILLSCHROMEBLACK_1080x.jpg?v=1745361636",
    "https://nogginboss.com/cdn/shop/files/BUFFALOBILLSCHROMESILVER_1080x.jpg?v=1745361636",
    "https://nogginboss.com/cdn/shop/files/BUFFALOBILLSCHROMEGOLD_1080x.jpg?v=1745361636",
    "https://nogginboss.com/cdn/shop/files/BUFFALOBILLSCHROMEBLUE_1080x.jpg?v=1745361585"
  ],
  "carolina-panthers": [
    "https://nogginboss.com/cdn/shop/files/PanthersBlack1_1080x.png?v=1690384135",
    "https://nogginboss.com/cdn/shop/files/PanthersGrey1_1080x.png?v=1690384135",
    "https://nogginboss.com/cdn/shop/files/PanthersWhite1_1080x.png?v=1690384135",
    "https://nogginboss.com/cdn/shop/files/CAROLINAPANTHERSCHROMEBLACK_1080x.jpg?v=1745361399",
    "https://nogginboss.com/cdn/shop/files/CAROLINAPANTHERSCHROMESILVER_1080x.jpg?v=1745361399"
  ],
  "chicago-bears": [
    "https://nogginboss.com/cdn/shop/files/BearsGrey1_1080x.png?v=1687895443",
    "https://nogginboss.com/cdn/shop/files/BearsWhite1_1080x.png?v=1687895208",
    "https://nogginboss.com/cdn/shop/files/BearsNavy1_1080x.png?v=1687895443",
    "https://nogginboss.com/cdn/shop/files/CHICAGOBEARSCHROMEBLACK_1080x.jpg?v=1745361069",
    "https://nogginboss.com/cdn/shop/files/CHICAGOBEARSCHROMESILVER_1080x.jpg?v=1745361069",
    "https://nogginboss.com/cdn/shop/files/CHICAGOBEARSCHROMEGOLD_1080x.jpg?v=1745361069",
    "https://nogginboss.com/cdn/shop/files/CHICAGOBEARSCHROMENAVY_1080x.jpg?v=1745361069"
  ],
  "cincinnati-bengals": [
    "https://nogginboss.com/cdn/shop/files/BengalsBlack1_1080x.png?v=1687895450",
    "https://nogginboss.com/cdn/shop/files/BengalsGrey1_1080x.png?v=1687895450",
    "https://nogginboss.com/cdn/shop/files/BengalsWhite1_1080x.png?v=1687895268",
    "https://nogginboss.com/cdn/shop/files/CINCINNATIBENGALSCHROMEBLACK_1080x.jpg?v=1745360856",
    "https://nogginboss.com/cdn/shop/files/CINCINNATIBENGALSCHROMESILVER_1080x.jpg?v=1745360856",
    "https://nogginboss.com/cdn/shop/files/CINCINNATIBENGALSCHROMEGOLD_1080x.jpg?v=1745360856"
  ],
  "cleveland-browns": [
    "https://nogginboss.com/cdn/shop/files/BrownsGrey1_1080x.png?v=1687895330",
    "https://nogginboss.com/cdn/shop/files/BrownsWhite1_1080x.png?v=1687895330",
    "https://nogginboss.com/cdn/shop/files/CLEVELANDBROWNSCHROMEBLACK_1080x.jpg?v=1745360812",
    "https://nogginboss.com/cdn/shop/files/CLEVELANDBROWNSCHROMESILVER_1080x.jpg?v=1745360812"
  ],
  "dallas-cowboys": [
    "https://nogginboss.com/cdn/shop/files/CowboysBlack_1080x.png?v=1694457310",
    "https://nogginboss.com/cdn/shop/files/CowboysGrey_1080x.png?v=1694457310",
    "https://nogginboss.com/cdn/shop/files/CowboysWhite_1080x.png?v=1694457310",
    "https://nogginboss.com/cdn/shop/products/CowboysNavy_1080x.png?v=1694457295",
    "https://nogginboss.com/cdn/shop/files/DALLASCOWBOYSCHROMESILVER_1080x.jpg?v=1747940065",
    "https://nogginboss.com/cdn/shop/files/DALLASCOWBOYSCHROMENAVY_1080x.jpg?v=1747940049"
  ],
  "denver-broncos": [
    "https://nogginboss.com/cdn/shop/files/BroncosBlack1_1080x.png?v=1690384160",
    "https://nogginboss.com/cdn/shop/files/BroncosGrey1_1080x.png?v=1690384160",
    "https://nogginboss.com/cdn/shop/files/BroncosWhite1_1080x.png?v=1687895389",
    "https://nogginboss.com/cdn/shop/files/BroncosNavy1_1080x.png?v=1690384160",
    "https://nogginboss.com/cdn/shop/files/DENVERBRONCOSCHROMEBLACK_1080x.jpg?v=1745460155",
    "https://nogginboss.com/cdn/shop/files/DENVERBRONCOSCHROMESILVER_1080x.jpg?v=1745460155",
    "https://nogginboss.com/cdn/shop/files/DENVERBRONCOSCHROMENAVY_1080x.jpg?v=1745460155",
    "https://nogginboss.com/cdn/shop/files/6A0A9476_1bb40356-3b4b-4532-984c-dc6202da012a_1080x.jpg?v=1728506063",
    "https://nogginboss.com/cdn/shop/files/6A0A9482_3aff05df-6244-4b6b-b216-a356424c5e02_1080x.jpg?v=1728506064"
  ],
  "detroit-lions": [
    "https://nogginboss.com/cdn/shop/files/LionsBlack1_1080x.png?v=1687895479",
    "https://nogginboss.com/cdn/shop/files/LionsGrey1_1080x.png?v=1687895479",
    "https://nogginboss.com/cdn/shop/files/LionsWhite1_1080x.png?v=1687895479",
    "https://nogginboss.com/cdn/shop/files/DETROITLIONSCHROMEBLACK_1080x.jpg?v=1745460149",
    "https://nogginboss.com/cdn/shop/files/DETROITLIONSCHROMESILVER_1080x.jpg?v=1745460149"
  ],
  "green-bay-packers": [
    "https://nogginboss.com/cdn/shop/files/PackersBlack1_1080x.png?v=1690384173",
    "https://nogginboss.com/cdn/shop/files/PackersGrey1_1080x.png?v=1700068722",
    "https://nogginboss.com/cdn/shop/files/PackersWhite1_1080x.png?v=1700068722",
    "https://nogginboss.com/cdn/shop/files/GREENBAYPACKERSCHROMEBLACK_1080x.jpg?v=1745419752",
    "https://nogginboss.com/cdn/shop/files/GREENBAYPACKERSCHROMESILVER_1080x.jpg?v=1745419733",
    "https://nogginboss.com/cdn/shop/files/GREENBAYPACKERSCHROMEGOLD_1080x.jpg?v=1745419752"
  ],
  "houston-texans": [
    "https://nogginboss.com/cdn/shop/files/TexansRed1_1080x.png?v=1690384254",
    "https://nogginboss.com/cdn/shop/files/TexansBlack1_1080x.png?v=1690384254",
    "https://nogginboss.com/cdn/shop/files/TexansGrey1_1080x.png?v=1690384254",
    "https://nogginboss.com/cdn/shop/files/TexansWhite1_1080x.png?v=1687895603",
    "https://nogginboss.com/cdn/shop/files/TexansNavy1_1080x.png?v=1690384254",
    "https://nogginboss.com/cdn/shop/files/HOUSTONTEXANSCHROMEBLACK_1080x.jpg?v=1745460144",
    "https://nogginboss.com/cdn/shop/files/HOUSTONTEXANSCHROMESILVER_1_1080x.jpg?v=1745460144"
  ],
  "indianapolis-colts": [
    "https://nogginboss.com/cdn/shop/files/ColtsBlack1_1080x.png?v=1723818615",
    "https://nogginboss.com/cdn/shop/files/ColtsGrey1_1080x.png?v=1723818615",
    "https://nogginboss.com/cdn/shop/files/ColtsWhite1_1080x.png?v=1723818615",
    "https://nogginboss.com/cdn/shop/files/NEW_ColtsRoyal_1080x.png?v=1723818605",
    "https://nogginboss.com/cdn/shop/files/INDIANAPOLISCOLTSCHROMEBLACK_1080x.jpg?v=1745460135",
    "https://nogginboss.com/cdn/shop/files/INDIANAPOLISCOLTSCHROMESILVER_1080x.jpg?v=1745460135",
    "https://nogginboss.com/cdn/shop/files/INDIANAPOLISCOLTSCHROMEGOLD_1080x.jpg?v=1745419377",
    "https://nogginboss.com/cdn/shop/files/NEW_ColtsRoyal_1080x.png?v=1723818605",
    "https://nogginboss.com/cdn/shop/files/INDIANAPOLISCOLTSCHROMEROYAL_1080x.jpg?v=1745460135"
  ],
  "jacksonville-jaguars": [
    "https://nogginboss.com/cdn/shop/files/JaguarsBlack1_1080x.png?v=1687895756",
    "https://nogginboss.com/cdn/shop/files/JaguarsGrey1_1080x.png?v=1687895755",
    "https://nogginboss.com/cdn/shop/files/JaguarsWhite1_1080x.png?v=1687895755",
    "https://nogginboss.com/cdn/shop/files/JACKSONVILLEJAGUARSCHROMEBLACK_1080x.jpg?v=1745418696",
    "https://nogginboss.com/cdn/shop/files/JACKSONVILLEJAGUARSCHROMESILVER_1080x.jpg?v=1745418693",
    "https://nogginboss.com/cdn/shop/files/JACKSONVILLEJAGUARSCHROMEGOLD_1080x.jpg?v=1745418694"
  ],
  "kansas-city-cheifs": [
    "https://nogginboss.com/cdn/shop/files/ChiefsRed1_1080x.png?v=1690384319",
    "https://nogginboss.com/cdn/shop/files/ChiefsBlack1_1080x.png?v=1690384319",
    "https://nogginboss.com/cdn/shop/files/ChiefsGrey1_1080x.png?v=1690384319",
    "https://nogginboss.com/cdn/shop/files/ChiefsWhite1_1080x.png?v=1687895812",
    "https://nogginboss.com/cdn/shop/files/KANSASCITYCHIEFSCHROMEBLACK_1080x.jpg?v=1745460128",
    "https://nogginboss.com/cdn/shop/files/KANSASCITYCHIEFSCHROMESILVER_1080x.jpg?v=1745460128",
    "https://nogginboss.com/cdn/shop/files/KANSASCITYCHIEFSCHROMEGOLD_1080x.jpg?v=1745460128"
  ],
  "las-vegas-raiders": [
    "https://nogginboss.com/cdn/shop/files/RaidersBlack1_1080x.png?v=1687895920",
    "https://nogginboss.com/cdn/shop/files/RaidersGrey1_1080x.png?v=1687895920",
    "https://nogginboss.com/cdn/shop/files/RaidersWhite1_1080x.png?v=1687895919",
    "https://nogginboss.com/cdn/shop/files/LASVEGASRAIDERSCHROMEBLACK_1080x.jpg?v=1745460124",
    "https://nogginboss.com/cdn/shop/files/LASVEGASRAIDERSCHROMESILVER_1080x.jpg?v=1745460124"
  ],
  "los-angeles-chargers": [
    "https://nogginboss.com/cdn/shop/files/ChargersBlack1_1080x.png?v=1690384333",
    "https://nogginboss.com/cdn/shop/files/ChargersGrey1_1080x.png?v=1690384333",
    "https://nogginboss.com/cdn/shop/files/ChargersWhite1_1080x.png?v=1690384333",
    "https://nogginboss.com/cdn/shop/files/LACHARGERSCHROMEBLACK_1080x.jpg?v=1745460110",
    "https://nogginboss.com/cdn/shop/files/LACHARGERSCHROMESILVER_1080x.jpg?v=1745460110",
    "https://nogginboss.com/cdn/shop/files/LACHARGERSCHROMEGOLD_1080x.jpg?v=1745460110",
    "https://nogginboss.com/cdn/shop/files/LACHARGERSCHROMEROYAL_1080x.jpg?v=1745460110"
  ],
  "los-angeles-rams": [
    "https://nogginboss.com/cdn/shop/files/RamsBlack1_1080x.png?v=1690384342",
    "https://nogginboss.com/cdn/shop/files/RamsGrey1_1080x.png?v=1690384342",
    "https://nogginboss.com/cdn/shop/files/RamsWhite1_1080x.png?v=1687896017",
    "https://nogginboss.com/cdn/shop/files/RamsRoyal1_1080x.png?v=1690384342",
    "https://nogginboss.com/cdn/shop/files/LARAMSCHROMESILVER_1080x.jpg?v=1745460106",
    "https://nogginboss.com/cdn/shop/files/LARAMSCHROMEGOLD_1080x.jpg?v=1745460106",
    "https://nogginboss.com/cdn/shop/files/LARAMSCHROMEROYAL_1080x.jpg?v=1745460106"
  ],
  "miami-dolphins": [
    "https://nogginboss.com/cdn/shop/files/DolphinsBlack1_1080x.png?v=1690384351",
    "https://nogginboss.com/cdn/shop/files/DolphinsGrey1_1080x.png?v=1690384351",
    "https://nogginboss.com/cdn/shop/files/DolphinsWhite1_1080x.png?v=1687896073",
    "https://nogginboss.com/cdn/shop/files/MIAMIDOLPHINSCHROMEBLACK_1080x.jpg?v=1745460102",
    "https://nogginboss.com/cdn/shop/files/MIAMIDOLPHINSCHROMESILVER_1080x.jpg?v=1745460102"
  ],
  "minnesota-vikings": [
    "https://nogginboss.com/cdn/shop/files/VikingsBlack1_1080x.png?v=1690384360",
    "https://nogginboss.com/cdn/shop/files/VikingsGrey1_1080x.png?v=1690384360",
    "https://nogginboss.com/cdn/shop/files/VikingsWhite1_1080x.png?v=1687896138",
    "https://nogginboss.com/cdn/shop/files/MINNESOTAVIKINGSCHROMEBLACK_1080x.jpg?v=1745460095",
    "https://nogginboss.com/cdn/shop/files/MINNESOTAVIKINGSCHROMESILVER_1080x.jpg?v=1745460095",
    "https://nogginboss.com/cdn/shop/files/MINNESOTAVIKINGSCHROMEGOLD_1080x.jpg?v=1745460095"
  ],
  "new-england-patriots": [
    "https://nogginboss.com/cdn/shop/files/PatriotsBlack1_1080x.png?v=1690384377",
    "https://nogginboss.com/cdn/shop/files/PatriotsGrey1_1080x.png?v=1690384377",
    "https://nogginboss.com/cdn/shop/files/PatriotsWhite1_1080x.png?v=1687896205",
    "https://nogginboss.com/cdn/shop/files/PatriotsNavy1_1080x.png?v=1690384377",
    "https://nogginboss.com/cdn/shop/files/NEWENGLANDPATRIOTSCHROMEBLACK_1080x.jpg?v=1745460091",
    "https://nogginboss.com/cdn/shop/files/NEWENGLANDPATRIOTSCHROMESILVER_1080x.jpg?v=1745460091",
    "https://nogginboss.com/cdn/shop/files/NEWENGLANDPATRIOTSCHROMEGOLD_1080x.jpg?v=1745417828",
    "https://nogginboss.com/cdn/shop/files/NEWENGLANDPATRIOTSCHROMENAVY_1080x.jpg?v=1745417828",
    "https://nogginboss.com/cdn/shop/files/6A0A9405_b258df6b-f6de-4b15-8ecb-31df7e9b70b0_1080x.jpg?v=1728505271",
    "https://nogginboss.com/cdn/shop/files/6A0A9410_e57389b4-9b7b-425b-a2ef-75a4095f20d2_1080x.jpg?v=1728505271",
    "https://nogginboss.com/cdn/shop/files/6A0A9400_a2f9390b-a68b-49e1-8b22-b03c1e089979_1080x.jpg?v=1728503629",
    "https://nogginboss.com/cdn/shop/files/6A0A9403_49f300d8-278b-4fe1-8fed-c7ace5275e20_1080x.jpg?v=1728505271"
  ],
  "new-orleans-saints": [
    "https://nogginboss.com/cdn/shop/files/SaintsBlack1_1080x.png?v=1687896271",
    "https://nogginboss.com/cdn/shop/files/SaintsGrey1_1080x.png?v=1691703463",
    "https://nogginboss.com/cdn/shop/files/SaintsWhite1_1080x.png?v=1691703463",
    "https://nogginboss.com/cdn/shop/files/NEWORLEANSSAINTSCHROMEBLACK_1080x.jpg?v=1745460085",
    "https://nogginboss.com/cdn/shop/files/NEWORLEANSSAINTSCHROMEGOLD_1080x.jpg?v=1745460085"
  ],
  "new-york-giants": [
    "https://nogginboss.com/cdn/shop/files/GiantsRed1_1080x.png?v=1687896348",
    "https://nogginboss.com/cdn/shop/files/GiantsGrey1_1080x.png?v=1691703411",
    "https://nogginboss.com/cdn/shop/files/GiantsWhite1_1080x.png?v=1687896348",
    "https://nogginboss.com/cdn/shop/files/GiantsRoyal1_1080x.png?v=1687896349",
    "https://nogginboss.com/cdn/shop/files/NYJETSCHROMESILVER2_1080x.jpg?v=1745442678",
    "https://nogginboss.com/cdn/shop/files/NYJETSCHROMEROYAL_1080x.jpg?v=1745442678"
  ],
  "new-york-jets": [
    "https://nogginboss.com/cdn/shop/files/Jets_BLK_1080x.png?v=1726237222",
    "https://nogginboss.com/cdn/shop/files/Jets_GRY_1080x.png?v=1726237222",
    "https://nogginboss.com/cdn/shop/files/Jets_WHT_1080x.png?v=1726237222",
    "https://nogginboss.com/cdn/shop/files/Jets_HGRN_1080x.png?v=1726237222",
    "https://nogginboss.com/cdn/shop/files/NYJETSCHROMEBLACKTB_1080x.jpg?v=1745460076",
    "https://nogginboss.com/cdn/shop/files/NYJETSCHROMESILVERTB_1080x.jpg?v=1745417669",
    "https://nogginboss.com/cdn/shop/files/NYJETSCHROMEGOLDTB_1080x.jpg?v=1745460076"
  ],
  "philadelphia-eagles": [
    "https://nogginboss.com/cdn/shop/files/EaglesBlack1_1080x.png?v=1690384563",
    "https://nogginboss.com/cdn/shop/files/EaglesGrey1_1080x.png?v=1700068955",
    "https://nogginboss.com/cdn/shop/files/EaglesWhite1_1080x.png?v=1700068955",
    "https://nogginboss.com/cdn/shop/files/EaglesHGreen1_1080x.png?v=1700068955",
    "https://nogginboss.com/cdn/shop/files/PHILADELPHIAEAGLESCHROMEBLACK_1_1080x.jpg?v=1745418265",
    "https://nogginboss.com/cdn/shop/files/PHILADELPHIAEAGLESCHROMESILVER_1080x.jpg?v=1745418251",
    "https://nogginboss.com/cdn/shop/files/6A0A9423_bd0f91d5-6d65-437e-8bf6-f4f82a4a3c5a_1080x.jpg?v=1728505428",
    "https://nogginboss.com/cdn/shop/files/6A0A9428_f23b4b26-145a-4846-93ce-5652c9f5e207_1080x.jpg?v=1728505427",
    "https://nogginboss.com/cdn/shop/files/PHILADELPHIAEAGLESCHROMEBLACKTB_1080x.jpg?v=1745460208",
    "https://nogginboss.com/cdn/shop/files/PHILADELPHIAEAGLESCHROMESILVERTB_1080x.jpg?v=1745460208"
  ],
  "pittsburgh-steelers": [
    "https://nogginboss.com/cdn/shop/files/SteelersBlack1_1080x.png?v=1687896547",
    "https://nogginboss.com/cdn/shop/files/SteelersGrey1_1080x.png?v=1693432603",
    "https://nogginboss.com/cdn/shop/files/SteelersWhite1_1080x.png?v=1693432603",
    "https://nogginboss.com/cdn/shop/files/PITTSBURGHSTEELERSCHROMEBLACK_1080x.jpg?v=1745460063",
    "https://nogginboss.com/cdn/shop/files/PITTSBURGHSTEELERSCHROMESILVER_1080x.jpg?v=1745460063",
    "https://nogginboss.com/cdn/shop/files/PITTSBURGHSTEELERSCHROMEGOLD_1080x.jpg?v=1745460063"
  ],
  "san-francisco-49ers": [
    "https://nogginboss.com/cdn/shop/files/49ersRed1_1080x.png?v=1690384446",
    "https://nogginboss.com/cdn/shop/files/49ersBlack1_1080x.png?v=1690384446",
    "https://nogginboss.com/cdn/shop/files/49ersGrey1_1080x.png?v=1690384446",
    "https://nogginboss.com/cdn/shop/files/49ersWhite1_1080x.png?v=1687896601",
    "https://nogginboss.com/cdn/shop/files/SF49ERSCHROMEBLACK_1080x.jpg?v=1745460058",
    "https://nogginboss.com/cdn/shop/files/SF49ERSCHROMESILVER_1080x.jpg?v=1745460058",
    "https://nogginboss.com/cdn/shop/files/SF49ERSCHROMEGOLD_1080x.jpg?v=1745460058"
  ],
  "seattle-seahawks": [
    "https://nogginboss.com/cdn/shop/files/SeahawksBlack1_1080x.png?v=1690384549",
    "https://nogginboss.com/cdn/shop/files/SeahawksGrey1_1080x.png?v=1690384549",
    "https://nogginboss.com/cdn/shop/files/SeahawksWhite1_1080x.png?v=1687896654",
    "https://nogginboss.com/cdn/shop/files/SeahawksNavy1_1080x.png?v=1690384549",
    "https://nogginboss.com/cdn/shop/files/SEATTLESEAHAWKSCHROMEBLACK_1080x.jpg?v=1745460054",
    "https://nogginboss.com/cdn/shop/files/SEATTLESEAHAWKSCHROMESILVER_1080x.jpg?v=1745460054",
    "https://nogginboss.com/cdn/shop/files/SEATTLESEAHAWKSCHROMEGOLD_1080x.jpg?v=1745460054",
    "https://nogginboss.com/cdn/shop/files/SEATTLESEAHAWKSCHROMEBLUE_1080x.jpg?v=1745460054",
    "https://nogginboss.com/cdn/shop/files/SEATTLESEAHAWKSCHROMENAVY_1080x.jpg?v=1745460054"
  ],
  "tampa-bay-buccaneers": [
    "https://nogginboss.com/cdn/shop/files/BuccaneersRed1_1080x.png?v=1690384470",
    "https://nogginboss.com/cdn/shop/files/BuccaneersBlack1_1080x.png?v=1690384470",
    "https://nogginboss.com/cdn/shop/files/BuccaneersGrey1_1080x.png?v=1690384470",
    "https://nogginboss.com/cdn/shop/files/BuccaneersWhite1_1080x.png?v=1687896936",
    "https://nogginboss.com/cdn/shop/files/TAMPABAYBUCCANEERSCHROMEBLACK_1080x.jpg?v=1745460046",
    "https://nogginboss.com/cdn/shop/files/TAMPABAYBUCCANEERSCHROMESILVER_1080x.jpg?v=1745460046",
    "https://nogginboss.com/cdn/shop/files/TAMPABAYBUCCANEERSCHROMEGOLD_1080x.jpg?v=1745365374"
  ],
  "tennessee-titans": [
    "https://nogginboss.com/cdn/shop/files/TitansRed1_1080x.png?v=1687896763",
    "https://nogginboss.com/cdn/shop/files/TitansBlack1_1080x.png?v=1690384480",
    "https://nogginboss.com/cdn/shop/files/TitansGrey1_1080x.png?v=1690384480",
    "https://nogginboss.com/cdn/shop/files/TitansWhite1_1080x.png?v=1687896763",
    "https://nogginboss.com/cdn/shop/files/TitansNavy1_1080x.png?v=1690384480",
    "https://nogginboss.com/cdn/shop/files/TENNESEETITANSCHROMEBLACK_1_1080x.jpg?v=1745460041",
    "https://nogginboss.com/cdn/shop/files/TENNESEETITANSCHROMESILVER_1_1080x.jpg?v=1745460041",
    "https://nogginboss.com/cdn/shop/files/TENNESEETITANSCHROMENAVY_1_1080x.jpg?v=1745460041"
  ],
  "washington-commanders": [
    "https://nogginboss.com/cdn/shop/files/CommandersBlack1_1080x.png?v=1687897044",
    "https://nogginboss.com/cdn/shop/files/CommandersGrey1_1080x.png?v=1687897044",
    "https://nogginboss.com/cdn/shop/files/CommandersWhite1_1080x.png?v=1687897045",
    "https://nogginboss.com/cdn/shop/files/WASHINGTONCOMMANDERSCHROMEBLACK_1_1080x.jpg?v=1747935048",
    "https://nogginboss.com/cdn/shop/files/WASHINGTONCOMMANDERSCHROMEGOLD_1_1080x.jpg?v=1747935027"
  ],
};